import { useCreateGroupMutation } from '../../../../../graphql'
import useCompanyId from 'hooks/useCompanyId'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useAddGroupHandler( options?: any ) {
	const companyId = useCompanyId()
	const [ createGroup ] = useCreateGroupMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( name: string, spendingLimit?: string ) => {
		const result = await createGroup( { variables: {
			name,
			spendingLimit: spendingLimit ? parseFloat( spendingLimit ) : null,
			companyId,
		} } )

		const { success, message } = result.data?.createGroup ?? {}

		if ( success ) {
			showSuccess( `createGroupSuccess${Date.now()}`, message ?? 'Successfully added group!' )
		} else {
			showError( `createGroupError${Date.now()}`, message ?? 'Sorry, an error occurred' )
		}
	}
}
